import React from 'react';
import { Box } from '@mui/material';
import { RADIUS } from '../../../theme/tokens';

/** Bloco de filtros das listagens: fundo neutro claro, sem sombra. */
export default function FilterPanel({ children }: { children: React.ReactNode }) {
  return (
    <Box
      role="search"
      aria-label="Filtros"
      sx={{
        p: { xs: 2, md: 3 },
        mb: 3,
        borderRadius: `${RADIUS.card}px`,
        border: 1,
        borderColor: 'divider',
        backgroundColor: 'background.subtle',
        // Campos brancos sobre o fundo neutro; botões com a mesma altura dos campos
        '& .MuiOutlinedInput-root': { backgroundColor: 'background.paper' },
        '& .MuiButton-root': { minHeight: 56 },
      }}
    >
      {children}
    </Box>
  );
}

/** Área de resultados das listagens (os itens já são cards). */
export function ResultsPanel({ children }: { children: React.ReactNode }) {
  return (
    <Box component="section" aria-label="Resultados" sx={{ minHeight: 320 }}>
      {children}
    </Box>
  );
}
